export enum Route {
    Contaminants = "contaminants",
}
